import {
  Fragment,
  useState,
  useCallback
} from 'react';
import { useTranslation } from 'react-i18next';

import i18n from '../../../lib/utils/i18n';
import EditableTable from '../../../lib/components/EditableTable/EditableTable';
import AlertNotification from '../../../lib/components/AlertNotification';
import { nonEmpty } from '../../../lib/validation';
import { listRefLabIndicators } from '../queries';
import {
  createRefLabIndicator,
  deleteRefLabIndicator,
  updateRefLabIndicator
} from '../mutations';

const queries = {
  listQuery: { query: listRefLabIndicators, name: 'listRefLabIndicators' },
  createMutation: { query: createRefLabIndicator, inputName: 'reflabindicator' },
  updateMutation: { query: updateRefLabIndicator, inputName: 'reflabindicator' },
  deleteMutation: { query: deleteRefLabIndicator, inputName: 'reflabindicator' }
};

const columns = [
  { id: 'name', label: i18n.t('labIndicatorsLabels.indicator'), type: 'text' },
  { id: 'unit', label: i18n.t('labIndicatorsLabels.unit'), type: 'text' },
  { id: 'refValue', label: i18n.t('labIndicatorsLabels.refValue'), type: 'text' },
];

const defaultState = {
  name: '',
  unit: '',
  refValue: '',
};

const validations = {
  name: [{ rule: nonEmpty, errorMessage: i18n.t('errorEmptyField') }],
  unit: [{ rule: nonEmpty, errorMessage: i18n.t('errorEmptyField') }],
};

function CleanWaterIndicatorsList() {
  const { t } = useTranslation();
  const [notification, setNotification] = useState(null);

  const onError = (err) => setNotification({
    severity: 'error',
    message: t('formGenericMessages.saveError', { error: err.message }),
  });

  const onSaveSuccess = () => {
    setNotification({
      severity: 'success',
      message: t('formGenericMessages.saveSuccess'),
    });
  };

  const onDeleteSuccess = () => {
    setNotification({
      severity: 'success',
      message: t('formGenericMessages.deleteSuccess'),
    });
  };

  const beforeSave = useCallback((data) => {
    delete data.__typename;
    return data;
  }, []);

  return (
    <Fragment>
      {notification && <AlertNotification {...notification} onClose={() => setNotification(null)} />}
      <EditableTable
        defaultState={defaultState}
        queries={queries}
        columns={columns}
        onError={onError}
        onSaveSuccess={onSaveSuccess}
        onDeleteSuccess={onDeleteSuccess}
        beforeSave={beforeSave}
        validations={validations}
      />
    </Fragment>
  );
}

export default CleanWaterIndicatorsList;
